import { type AxiosResponse } from "axios"
import Util from "../util"
import getEnv from "../util/env"
import httpClient from "../http/interceptors"

const backendService = {
  fetchUseCases: (): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl("central/usecases", "cxcore"))
  },
  fetchModels: (): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl("central/model/models", "cxcore"))
  },
  fetchAspects: (modelId: string = ""): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl(`central/models/aspects/${modelId}`, "cxcore"))
  },
  fetchConnectorOffersMetaData: (): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl("fetchConnectorOffersMetaData", "backend"))
  },
  publishCsv: (payload: {
    csvToNuggetConverterId: string
    csvToAspectConverterId: string
    allowedBPNs: string[]
    file: any
  }): Promise<AxiosResponse> => {
    return httpClient.post(Util.getRestApiUrl("provisions/csv", "minifi"), payload.file, {
      params: {
        csvToNuggetConverterId: payload.csvToNuggetConverterId,
        csvToAspectConverterId: payload.csvToAspectConverterId,
        allowedBPNs: JSON.stringify(payload.allowedBPNs || [])
      }
    })
  },
  getBPNByCompany: (seachText: string) => {
    return httpClient.get(Util.getRestApiUrl("discovery/bpdm/bpnl", "cxcore"), {
      params: {
        legalName: seachText
      }
    })
  },
  fetchAspectsCount: (): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl("provider/documents/aspects/count", "cxcore"))
  },
  fetchConectorsCount: (): Promise<AxiosResponse> => {
    return httpClient.post(Util.getRestApiUrl("discovery/edc/connector/fetch", "cxcore"), [
      getEnv("VITE_BPN_NUMBER")
    ])
  }
}

export default backendService
